import { render, staticRenderFns } from "./PostCountBox.vue?vue&type=template&id=e644916a&scoped=true&"
import script from "./PostCountBox.vue?vue&type=script&lang=ts&"
export * from "./PostCountBox.vue?vue&type=script&lang=ts&"
import style0 from "./post_count_box.scss?vue&type=style&index=0&id=e644916a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e644916a",
  null
  
)

export default component.exports